<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
          <div v-show="IfElese == '1'">
            <el-form ref="form" :model="Ldata" label-width="80px">
              <el-form-item label="房间号">
                <el-input v-model="Ldata.roomCode" disabled></el-input>
              </el-form-item>
               <el-form-item label="业主姓名">
                <el-input v-model="Ldata.customerName" disabled></el-input>
              </el-form-item>
                <el-form-item label="迁出日期">
                <el-date-picker type="date" placeholder="选择日期" v-model="DateS" @change="DataTime" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="remasks"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-show="IfElese == '2'">
              <el-form ref="form" :model="Ldata" label-width="80px">
              <el-form-item label="房间号">
                <el-input v-model="Ldata.roomCode" disabled></el-input>
              </el-form-item>
               <el-form-item label="建筑面积">
                <el-input v-model="Ldata.buildArea" disabled></el-input>
              </el-form-item>
                <el-form-item label="业主姓名">
               <el-input v-model="customerName" ></el-input>
              </el-form-item>
              <el-form-item label="证件号">
               <el-input v-model="customer" ></el-input>
              </el-form-item>
              <el-form-item label="联系方式">
               <el-input v-model="Phone" ></el-input>
              </el-form-item>
              <el-form-item label="通讯住址">
               <el-input v-model="Site" ></el-input>
              </el-form-item>
              <el-form-item label="住户类别">
               <el-select v-model="RoomType" placeholder="请选择住户类别">
                <el-option label="业主" value="1"></el-option>
                <el-option label="租户" value="2"></el-option>
              </el-select>
              </el-form-item>
              <el-form-item label="房间状态">
               <el-select v-model="roomStatus" placeholder="请选择房间状态">
                  <el-option label="空置" value="1"></el-option>
                  <el-option label="入住" value="2"></el-option>
                  <el-option label="已租" value="3"></el-option>
                  <el-option label="迁出" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入住日期">
                <el-date-picker type="date" placeholder="选择日期" v-model="DateST" @change="DatETime" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="收费日期">
                <el-date-picker type="date" placeholder="选择日期" v-model="DateSTO" @change="DatEsTime" style="width: 100%;"></el-date-picker>
              </el-form-item>
              
              <el-form-item label="备注">
                <el-input type="textarea" v-model="remasks"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
 components: {},
  name: "OwnerInDia",
  data() {
    return {
    options:[], // 组织结构
     value: [],
     optionsone: [{
          valueone: '1',
          labelone: '是'
        }, {
          valueone: '0',
          labelone: '否'
        }],
        value: '',
        valueone: '',
        disburse:[{
          disburseval: '0',
          disburselab: '预算'
        }, {
          disburseval: '1',
          disburselab: '非预算'
        },
        {
          disburseval: '2',
          disburselab: '其他'
        }],
        disburseval:"",
        dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     Ldata:{},
     display:"",
     detection:"",
     UserDisplay:"",
     IfElese:"1",
     DateS:"",
     remasks:"",
     Dtime:"",

     customerName:"",
     customer:"",
     DateST:"",
     DateSTO:"",
     RoomType:"",
     Phone:"",
     roomStatus:"",
     Site:"",
     DtimeT:"",
     DtimeS:"",
     floorData:{},
    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        if(this.IfElese == "1"){
            this.DateS = ""
        this.remasks = ""
        }else{
           this.remasks = ""
        this.customerName=""
        this.customer=""
        this.DateST=""
        this.DateSTO=""
        }
      }
    }
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false
    },
    modification(){
      if(this.IfElese == "1"){
        let obj = {
          "id":this.Ldata.customerId
        }
     this.$http.post(this.$requestUrl.DELETE_OWNER,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              this.$emit("Visible",false)
              this.$message({
                  type: 'success',
                  message: '迁出成功!'
              });
              this.dialogVisible = false
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      }else if(this.IfElese == "2"){
        // POST_OWNER_ADD
        let obj = {
          "name":this.customerName,
          "projectId":this.floorData.projectIdT,
          "floorId": this.floorData.id,
          "floorName": this.floorData.label,
          "roomId":this.Ldata.roomId,
          "idCode":this.customer,
          "telPhone":this.Phone,
          "roomStatus":this.roomStatus,
          "customerType":this.RoomType,
          "remarks":this.remasks,
          "checkInDate":this.DtimeT,
          "chargeTime":this.DtimeS,
        }
        if(obj.name != "" || obj.name != null || obj.name != undefined ){
          if(obj.customerType != "" || obj.customerType != null || obj.customerType != undefined ){
              if(obj.roomStatus != "" || obj.roomStatus != null || obj.roomStatus != undefined ){
                  if(obj.chargeTime != "" || obj.chargeTime != null || obj.chargeTime != undefined ){
                    if(obj.chargeTime != "" || obj.chargeTime != null || obj.chargeTime != undefined ){
                         this.$http.post(this.$requestUrl.POST_OWNER_ADD,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              this.$emit("Visible",false)
              this.$message({
                  type: 'success',
                  message: '迁入成功!'
              });
              this.dialogVisible = false
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
                    }else{
                       this.$message({
                        type: "warning",
                        message: "请选择开始收费日期"
                    })
                    }
                  }else{
                      this.$message({
                        type: "warning",
                        message: "请选择入住日期"
                    })
                  }
              }else{
                 this.$message({
                        type: "warning",
                        message: "请选择房间状态"
                    })
              }
          }else{
                 this.$message({
                        type: "warning",
                        message: "请选择住户类型"
                    })
              }
        }else{
                 this.$message({
                        type: "warning",
                        message: "请填写业主姓名"
                    })
              }
      }
    },
    DataTime(val){
      let date = val;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let time = year+"-"+month+"-"+dates
        this.Dtime = time
    },
    DatETime(val){
        let date = val;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let time = year+"-"+month+"-"+dates
        this.DtimeT = time
    },
    DatEsTime(val){
        let date = val;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let time = year+"-"+month+"-"+dates
        this.DtimeS = time
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
      // console.log(this.formLabelAlign.obj)
    if(this.UserDisplay == 1){
        this.valueone =""
        this.disburseval =""
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>